import script from "./NavigationMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationMenu.vue?vue&type=style&index=0&id=726eea24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726eea24"]])

export default __exports__